<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
  <br/><br/>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutGap="10px" align="end" >
  <button mat-stroked-button mat-dialog-close color="warn">{{"CANCEL" | translate}}</button>
  <button mat-stroked-button [mat-dialog-close]='true' color="primary">{{"CONFIRM" | translate}}</button>
</mat-dialog-actions>
